export default "__VITE_ASSET__528aedaf__"